export enum PowerType {
  TOTAL = 'total',
  AVERAGE = 'average',
  MIN = 'min',
  MAX = 'max'
}
